import ajax from '../ajax'


// https://test.vimiuvr.com/   //日常使用

// 'https://api.vimiuvr.com'   //打包线上
export function  HomeApi(params) {
    return ajax({
        method:'get',
        url: '/home',
        params
    })
}
export function  InfoApi(params) {
    return ajax({
        method:'get',
        url: '/info',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/a/index.js